import { render, staticRenderFns } from "./TransferTokensModal.vue?vue&type=template&id=7d45e1ef&scoped=true"
import script from "./TransferTokensModal.vue?vue&type=script&lang=ts"
export * from "./TransferTokensModal.vue?vue&type=script&lang=ts"
import style0 from "./TransferTokensModal.vue?vue&type=style&index=0&id=7d45e1ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45e1ef",
  null
  
)

export default component.exports